import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ToastModule } from 'primeng/toast';
import { MatSelectModule } from '@angular/material/select';
import { NgxEditorModule } from 'ngx-editor';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { NgApexchartsModule } from 'ng-apexcharts';
import { BreadcrumbsComponent } from '../features/common/breadcrumbs/breadcrumbs.component';
import { FooterComponent } from '../features/common/footer/footer.component';
import { CollapseHeaderModule } from '../features/common/collapse-header/collapse-header.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { DateRangePickerModule } from '../features/common/date-range-picker/date-range-picker.module';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    FooterComponent
  ],
  
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgScrollbarModule,
    ToastModule,
    MatSelectModule,
    NgxEditorModule,
    BsDatepickerModule.forRoot(),
    NgApexchartsModule,
    CollapseHeaderModule,
    PopoverModule,
    DateRangePickerModule,
    DatePickerModule,
    SelectModule,
    MultiSelectModule
  ],
  exports: [
    BreadcrumbsComponent,
    FooterComponent,
    FormsModule,
    ReactiveFormsModule,
    NgScrollbarModule,
    ToastModule,
    MatSelectModule,
    NgxEditorModule,
    BsDatepickerModule,
    NgApexchartsModule,
    CollapseHeaderModule,
    PopoverModule,
    DateRangePickerModule,
    DatePickerModule,
    SelectModule,
    MultiSelectModule
  ],
  providers: [
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    BsDatepickerConfig
  ]
})
export class SharedModule { }
